export default __webpack_public_path__ + "static/media/walletconnect.d94c4d9d.svg";